import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { Box, AHText, Input } from "arkh";
import { useIntl } from "react-intl";

export function IntegrationInput(props: {
  placeholder?: string;
  value: string;
  onChangeText: (text: string) => void;
  label?: React.ReactNode;
  type: "password" | "email" | "username" | "api-key" | "url";
}) {
  const placeholder = useTypePlaceholder(props.type);
  return (
    <Box spaceVertical="small">
      <AHText spaceLeft="xsmall" spaceBottom="small" type="subtitle">
        {props.label ?? placeholder}
      </AHText>
      <Input
        {...props}
        placeholder={props.placeholder ?? placeholder}
        textContentType={"none"}
        secureTextEntry={props.type === "password"}
        autoCapitalize={"none"}
        autoComplete={"off"}
        keyboardType={
          props.type === "url" || props.type === "api-key"
            ? "url"
            : props.type === "email"
              ? "email-address"
              : "default"
        }
      />
    </Box>
  );
}

function useTypePlaceholder(
  type: "password" | "email" | "username" | "api-key" | "url"
) {
  const tokens = useIntlTokens();
  const intl = useIntl();
  switch (type) {
    case "email":
      return tokens.Email;
    case "password":
      return intl.formatMessage({
        defaultMessage: "Password",
        description: "IntegrationActivateInput password placeholder",
      });
    case "username":
      return intl.formatMessage({
        defaultMessage: "Username",
        description: "IntegrationActivateInput username placeholder",
      });
    case "api-key":
      return intl.formatMessage({
        defaultMessage: "API-Key",
        description: "IntegrationActivateInput api-key placeholder",
      });
    case "url":
      return intl.formatMessage({
        defaultMessage: "URL",
        description: "IntegrationActivateInput url placeholder",
      });
  }
}
